import type { ComponentProps } from 'react';
import { useSlots } from '../SlotContext';

/** Provides the modal's accessible description through an internally generated ID referenced by aria-describedby. */
export const Description = (props: Omit<ComponentProps<'p'>, 'id'>) => {
  const { descriptionId } = useSlots();
  return <p {...props} id={descriptionId} />;
};
